import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { BillingAccountUtils } from 'app/page/orders/utils/billing-account-utils';
import { SwitchLink } from 'app/components/common/switch-link/';
import { i18n } from 'app/i18n';
import { selectBillingAccounts, selectBillingAccountIdOrThrow } from 'app/page/orders/redux/order-selectors';
import { AddressMapper } from 'app/page/orders/mapper/address-mapper';
import houseWithTreeIcon from 'app/resources/house-with-tree.svg';
import { BillingAccount } from 'app/page/orders/model/billing-account';
import { NavigationService, navigationService } from 'app/service/navigation-service';

export const AddressSwitchLink: FC = () => {
    const selectedBillingAccountId = useSelector(selectBillingAccountIdOrThrow);
    const billingAccounts = useSelector(selectBillingAccounts);

    const billingAccount: BillingAccount = BillingAccountUtils.getBillingAccount(
        billingAccounts,
        selectedBillingAccountId,
    );
    const { activeOrders, selectedOrderId } = billingAccount;

    if (!selectedOrderId || Object.keys(activeOrders).length <= 1) {
        return null;
    }

    return (
        <SwitchLink
            title={i18n.components.switchLink.address}
            text={AddressMapper.toDisplayStreet(activeOrders[selectedOrderId].order.deliveryServiceAddress!)}
            icon={{
                src: houseWithTreeIcon,
                alt: i18n.image.houseWithTree,
            }}
            onClick={() => navigationService.goToPath(NavigationService.CHOOSE_SERVICE_LOCATION)}
        />
    );
};
